const education = 
    [
        {
            id: "01",
            date: "Apr 2021 - Apr 2024", 
            school: "Nanyang Polytechnic",    
            certificate: "Diploma in Applied AI & Analytics",
            content: "Grade: 3.96\
            *‎ \
            *- Awards - \
            *‣ Graduated with Merit within the top 10% of the graduating cohort.\
            *‣ Awarded the Director's List for 5 semesters throughout the course of study.\
            *‣ Awarded the CSIT-Nanyang Scholarship (Mid-term) in 2022.\
            *‣ Obtained 8 Distinctions and 27 'A' grades out of 32 core modules and prescribed electives.\
            *‣ Specialised in Business Analytics, Data Science, Machine Learning, and Big Data Management.\
            *‎ \
            *- Activities - \
            *‣ 2021-2024: Class Chairperson\
            *‣ 2023&2024: NYP Open House Student Helper\
            *‣ 2022&2023: NYP Freshmen Orientation\
            *‣ 2022: Student Mentor\
            *‣ 2022: Student Peer Tutor\
            *‎ \
            *Achieved the highest grade of 'Distinction' for Co-Curricular Activities.",
        },
  
        {
            id: "02",
            date: "Jan 2017 - Dec 2020", 
            school: "Beatty Secondary School",
            certificate: "GCE 'O' Level",
            content: "*- Co-curricular Activities - \
            *‣ 2019-2020: Sports Leader EXCO\
            *‣ 2018: Sports Leader Member\
            *‣ 2017-2020: Canoeing Member\
            *‣ 2017: Chinese Orchestra Member\
            *‎ \
            *- Awards - \
            *‣ 2020: Edusave EAGLES\
            *‣ 2019: NYAA Silver\
            *‎ \
            *- Results -\
            *L1R4: 10 (Net), 12 (Raw) \
            *L1R5: 16 (Net), 18 (Raw)",
        }
  ];
  
  export default education;
  